// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"map_pageContainer__ptnkB","tabContainer":"map_tabContainer__6SaCC"};